import { useState, useEffect } from "react";
import DocumentoCard from "../../DocumentoCard/index";
import { useTheme } from "@mui/material/styles";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import {
  Grid,
  Typography,
  Divider,
  Box,
  Fade,
  Paper,
  Card,
} from "@mui/material";
import { Skeleton } from "@mui/material";
import Button from "@mui/material/Button";
import { addDocumentoCliente } from "../../../api/chamadasApi";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";
import { CLIENTEDOCUMENTOS } from "../../../util/typesReactQuery";
import { useMutation, useQueryClient } from "react-query";
import useStyles from "./styles";
import { ButtonCustom } from "../../Botoes/Button";
import useAlert from "../../../hooks/useAlert";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import { FichaCadastral } from "../../FichaCadastral";
import CloseIcon from "@mui/icons-material/Close";

const Documento = ({ documentos, loading, tiposDocumento, userID }) => {
  const initialStateDoc = {
    idTipoDocumento: 0,
    base64: "",
    nomeArquivo: "",
    idCliente: userID,
    contentType: "",
    tamanho: 0,
  };

  const { showAlertError, showAlertSuccess } = useAlert();
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState(initialStateDoc);
  const [isHoverDrag, setIsHoverDrg] = useState(false);
  const [showUploadArea, setShowUploadArea] = useState(false);
  const theme = useTheme();
  const queryClient = useQueryClient();

  const mutationAddDocumento = useMutation(addDocumentoCliente, {
    onSuccess: (response) => {
      if (response.errorMessage && response.errorMessage.length > 0) {
        showAlertError(response.errorMessage);
      } else {
        showAlertSuccess("Oba, seu documento foi anexado com sucesso");
        setFormData(initialStateDoc);
        setShowUploadArea(false);
      }
    },
    onError: async (err, variables, context) => {
      showAlertError(
        "Ops, Algo deu errado, por favor informe ao suporte tecnico o seguinte erro - " +
          err
      );
    },
    onSettled: async () => {
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
      queryClient.invalidateQueries(CLIENTEDOCUMENTOS);
    },
  });

  const handleChangeTipoDocumento = (event) => {
    setFormData({
      ...formData,
      idTipoDocumento: event.target.value,
    });
  };

  const getBase64 = (file, cb) => {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      cb(reader.result);
    };
    reader.onerror = function (error) {
      console.error("Error: ", error);
    };
  };

  const preventBrowserDefault = (e) => {
    e.preventDefault();
  };

  const changeHoverDrag = (value) => {
    setIsHoverDrg(() => value);
  };

  const eventsDrag = {
    onDragEnter: (e) => {
      preventBrowserDefault(e);
      changeHoverDrag(true);
    },
    onDragOver: (e) => {
      preventBrowserDefault(e);
      changeHoverDrag(true);
    },
    onDragLeave: (e) => {
      preventBrowserDefault(e);
      changeHoverDrag(false);
    },
    onDrop: (e) => {
      preventBrowserDefault(e);
      handlerChangeDoc(e);
      changeHoverDrag(false);
    },
  };

  const handlerChangeDoc = (event) => {
    let file = null;

    if (!!event?.dataTransfer) {
      file = event.dataTransfer.files[0];
      setShowUploadArea(true);
    } else file = event.target.files[0];

    // transforma em base 64
    getBase64(file, async (result) => {
      setFormData({
        ...formData,
        nomeArquivo: file.name,
        base64: result,
        tamanho: file.size,
        contentType: file.type,
      });
      setShowUploadArea(true);
    });
  };

  const handlerEnviarDoc = (event) => {
    event.preventDefault();
    setIsLoading(true);
    mutationAddDocumento.mutate(formData);
  };

  const resetUpload = () => {
    setFormData(initialStateDoc);
    setShowUploadArea(false);
  };

  const classes = useStyles();

  return (
    <Grid item xs={12} className={classes.container}>
      {/* <FichaCadastral
        ClienteId={userID}
        onSave={() => {
          queryClient.invalidateQueries(CLIENTEDOCUMENTOS);
          queryClient.invalidateQueries();
        }}
      /> */}
      <Grid
        item
        xs={12}
        container
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Typography variant="h6">Adicionar novo documento</Typography>
        {showUploadArea && (
          <Button size="small" onClick={resetUpload} startIcon={<CloseIcon />}>
            Cancelar
          </Button>
        )}
      </Grid>

      {/* Área de Upload Integrada */}
      <Paper
        elevation={1}
        className={`${classes.uploadArea} ${
          showUploadArea ? classes.uploadAreaExpanded : ""
        }`}
        sx={
          isHoverDrag
            ? {
                border: `2px dashed ${theme.palette.primary.main}`,
                backgroundColor: "action.hover",
              }
            : {}
        }
        {...eventsDrag}
      >
        {isLoading ? (
          <>
            <Skeleton variant="rectangular" height={80} sx={{ mt: 2 }} />
            <Skeleton variant="rectangular" height={50} sx={{ mt: 2 }} />
          </>
        ) : (
          <>
            {isHoverDrag ? (
              <Box className={classes.dragActive}>
                <FileDownloadIcon
                  fontSize="large"
                  sx={{ color: `${theme.palette.primary.main}`, mb: 1 }}
                />
                <Typography variant="h6" align="center">
                  Solte aqui para adicionar o arquivo
                </Typography>
              </Box>
            ) : (
              <>
                {!showUploadArea ? (
                  <Box className={classes.uploadInitial}>
                    <DriveFolderUploadIcon
                      fontSize="large"
                      sx={{ color: "text.secondary", mb: 2, fontSize: 48 }}
                    />
                    <Typography variant="body1" gutterBottom>
                      Solte o arquivo aqui ou
                    </Typography>
                    <Button
                      component="label"
                      variant="contained"
                      size="medium"
                      startIcon={<DriveFolderUploadIcon />}
                    >
                      Selecionar arquivo
                      <input
                        type="file"
                        id="file"
                        accept="*/*"
                        hidden
                        onChange={handlerChangeDoc}
                      />
                    </Button>
                    <Typography
                      variant="caption"
                      display="block"
                      sx={{ mt: 1, color: "text.secondary" }}
                    >
                      Seu arquivo não deve ultrapassar 5MB
                    </Typography>
                  </Box>
                ) : (
                  <Box className={classes.uploadWithFile}>
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={12} sm={4} md={3}>
                        {formData.contentType === "application/pdf" ? (
                          <PictureAsPdfIcon
                            fontSize="large"
                            sx={{
                              fontSize: 48,
                              color: theme.palette.error.main,
                            }}
                          />
                        ) : formData.contentType === "image/png" ||
                          formData.contentType === "image/jpeg" ||
                          formData.contentType === "image/webp" ? (
                          <Box
                            component="img"
                            src={formData.base64}
                            className={classes.filePreview}
                          />
                        ) : (
                          <InsertDriveFileIcon
                            fontSize="large"
                            sx={{
                              fontSize: 48,
                              color: theme.palette.primary.main,
                            }}
                          />
                        )}
                        <Typography
                          variant="body2"
                          noWrap
                          sx={{ maxWidth: 120, mt: 1 }}
                        >
                          {formData.nomeArquivo}
                        </Typography>
                      </Grid>

                      <Grid item xs={12} sm={8} md={9}>
                        <Typography sx={{ fontSize: ".875rem", mb: 1 }}>
                          Qual o tipo de documento?
                        </Typography>
                        <FormControl
                          fullWidth
                          error={formData.idTipoDocumento <= 0}
                          size="small"
                        >
                          <Select
                            label="Qual o tipo de documento?"
                            value={formData.idTipoDocumento}
                            onChange={handleChangeTipoDocumento}
                          >
                            <MenuItem value={0}>Escolha uma opção</MenuItem>
                            {tiposDocumento?.data?.map((i, index) => {
                              return (
                                <MenuItem key={index} value={i.id}>
                                  {i.descricao}
                                </MenuItem>
                              );
                            })}
                          </Select>
                          {formData.idTipoDocumento <= 0 && (
                            <FormHelperText>
                              É necessário escolher uma opção
                            </FormHelperText>
                          )}
                        </FormControl>

                        <Box sx={{ mt: 2, display: "flex", gap: 1 }}>
                          <Button
                            variant="contained"
                            onClick={handlerEnviarDoc}
                            disabled={formData.idTipoDocumento <= 0}
                          >
                            Enviar documento
                          </Button>
                          <Button component="label" variant="outlined">
                            Trocar arquivo
                            <input
                              type="file"
                              id="file"
                              accept="*/*"
                              hidden
                              onChange={handlerChangeDoc}
                            />
                          </Button>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                )}
              </>
            )}
          </>
        )}
      </Paper>

      <Divider sx={{ my: 3 }} />

      <Grid
        container
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h6">Documentos adicionados</Typography>
      </Grid>

      <Grid container sx={{ pl: 2 }} spacing={2}>
        {loading || isLoading ? (
          <>
            {Array.from({ length: 4 }, (_, index) => (
              <Grid item xs={12} key={index}>
                <Skeleton variant="rectangular" height={150} sx={{ mt: 2 }} />
              </Grid>
            ))}
          </>
        ) : (
          documentos &&
          documentos?.map((page) =>
            page?.data?.map(
              (doc, index) =>
                doc.base64 !== "" && (
                  <Grid key={index} item md={4} xs={6} sx={{ mt: 3 }} gap={2}>
                    <Box
                      fullWidth
                      mb={2}
                      sx={{
                        display: "flex !important",
                        justifyContent: "center !important",
                      }}
                      key={index}
                    >
                      <DocumentoCard documento={doc} key={index} />
                    </Box>
                  </Grid>
                )
            )
          )
        )}

        {documentos === undefined && (
          <Grid item xs={12}>
            <Typography
              variant="body1"
              color="textSecondary"
              align="center"
              sx={{ py: 3 }}
            >
              Ainda não há documentos anexados em seu cadastro
            </Typography>
          </Grid>
        )}
      </Grid>

      <Divider sx={{ my: 3 }} />
    </Grid>
  );
};

export default Documento;
